import React from "react";
import { IconType } from "react-icons";
import { GoChevronDown } from "react-icons/go";
import "../App.css";

type Props = {
  Icon: IconType | string;
  Title: string;
  Description: string;
  open: boolean;
  onClick: () => void;
};

const ServiziListElement: React.FC<Props> = ({
  Icon,
  Title,
  Description,
  open,
  onClick,
}) => (
  <button 
    className={`
      w-full max-w-2xl mx-auto
      sm:hover:shadow-2xl
      rounded-xl  border-0
      transition-all duration-300      
      cursor-pointer
      backdrop-blur
      ${open ? "shadow-2xl" : "shadow-md"}
    `}
    onClick={onClick}
    tabIndex={0}    
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") onClick();
    }}
  >
    <div className="flex items-center justify-between px-6 py-6">
      <span className="flex items-center gap-8">
        {typeof Icon === 'string' ? (
          <img 
            src={Icon} 
            alt={Title} 
            className="w-12 h-12 md:w-16 md:h-16 object-contain drop-shadow service-icon-blue" 
          />
        ) : (
          <Icon className="text-4xl md:text-5xl text-sky-600 drop-shadow" />
        )}
        <span className="text-xl md:text-2xl font-semibold text-font-header">{Title}</span>
      </span>
      <GoChevronDown
        className={`
          text-3xl transition-transform duration-300
          ${open ? "rotate-180 text-sky-600" : "rotate-0 text-gray-400"}
        `}
      />
    </div>
    <div
      id={`desc-${Title.replace(/\s+/g, "-")}`}
      className={`
        overflow-hidden transition-all duration-500 px-6
        ${open ? "max-h-80 opacity-100 py-4" : "max-h-0 opacity-0 py-0"}
      `}
    >
      <div className="border-t border-t-font-header  pt-8">
        <p className="text-xl leading-relaxed text-gray-600 mb-4">
          {Description}
        </p>
      </div>
    </div>
  </button>
);

export default ServiziListElement;
